import { apiInstance } from 'utils/request'
import { ENTITY_NAMES } from 'const/api'
import { FIELD_NAMES } from 'const/forms'
import parseError from 'helpers/parseServerError'

export const getGiveaways = ({ page, filters, sorter, search }) =>
  apiInstance
    .get(`/${ENTITY_NAMES.giveaways}`, {
      params: {
        filter: {
          search: search ? encodeURIComponent(search) : null,
          ...filters,
        },
        sort: sorter || FIELD_NAMES.id,
        page: {
          number: page,
          size: 20,
        },
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get Giveaways')
    })

export const createGiveaway = (data) =>
  apiInstance
    .post(`/${ENTITY_NAMES.giveaways}`, {
      data,
    })
    .catch((error) => {
      parseError(error, "Giveaways hasn't been created")
    })

export const updateGiveaway = ({ data, updateImage }) =>
  apiInstance
    .patch(`/${ENTITY_NAMES.giveaways}/${data.id}`, {
      data,
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(
        error,
        updateImage
          ? "Giveaways images hasn't been updated"
          : "Giveaways hasn't been updated"
      )
    })

export const deleteGiveaway = (id) =>
  apiInstance
    .delete(`/${ENTITY_NAMES.giveaways}/${id}`)
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Giveaways hasn't been deleted")
    })
